import { $, $all, on, forEach, addClass, removeClass } from "@olmokit/dom";
import { post } from "@olmokit/core/fragments/ajax";
import scrollLock from "@olmokit/core/scroll/lock";
import "./index.scss";

/**
* Component: VisualLanding
*/
export function VisualLanding() {
  console.log("VisualLanding mounted.");
    
  const $image = $all('.VisualLanding:columnSlab__img');
  forEach($image, (image) => {
    on(image, 'click', () => {
      console.log(image.getAttribute('data-original'));
      const src = image.getAttribute('data-original');
      PostLargeImage(src);
    });
  });
    
}

function PostLargeImage(src) {
  post('image', {
    data: {
      src: src,
    },
  }).then(({ data }) => {
    const $image = $('.ImageFullContainer');
    $image.innerHTML = data;
    $image.style.display = 'block';
    scrollLock.disable(document.body);
    const $close = $('.close', $image);

    on($close, 'click', () => {
      $image.style.display = 'none';
      scrollLock.enable(document.body);
    });

    // use keyboard to close img
    document.addEventListener('keydown', evt => {
      if (evt.key === 'Escape') {
        $image.style.display = 'none';
        scrollLock.enable(document.body);
      }
    });

  });

}